import FlowFooter from './FlowFooter';

type DesktopFlowFooterProps = {
  primaryLabel?: string;
  onPrimary?: () => void;
  secondaryLabel: string;
  onSecondary: () => void;
};

/**
 * DesktopFlowFooter — Desktop wrapper around FlowFooter that constrains
 * button width to `max-w-lg` and adds vertical margin (`my-6`).
 *
 * Use this in desktop pages instead of manually wrapping `<FlowFooter>`
 * in a sizing div. Mobile pages should use `<FlowFooter>` directly.
 */
export default function DesktopFlowFooter(props: DesktopFlowFooterProps) {
  return (
    <div className="w-full max-w-lg my-6">
      <FlowFooter {...props} />
    </div>
  );
}
